import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import { h4Style } from '../../../components/H4';
import { colors } from '../../../styles/constants';
import { FAQ_URL } from '../constants';
import messages from './messages';

const Content = styled.div`
  ${tw`flex flex-col`}
`;

const Header = styled.p`
  ${h4Style}
  ${tw`lg:ml-abs1 lg:ml-abs3 lg:my-1
  ml-0 cursor-pointer`}
`;

const CategoryLink = styled(NavLink)`
  ${tw`text-left ml-0 mb-def lg:ml-abs2 no-underline
    text-text text-h4 font-medium`};
  color: ${(props) => props.active && `${colors.terciary500}`};
  border-left: ${(props) => props.active && `solid 4px ${colors.terciary500}`};
  padding-left: ${(props) => props.active && '0.8rem'};
  font-size: 1.8rem !important;
  @media (min-width: 992px) {
    padding-left: 0.8rem;
  }
  &:hover {
    ${tw`text-terciary500 cursor-pointer`};
  }
`;

const Categories = ({ categories, categoryName, redirectHome }) => (
  <Content>
    <Header id="stickyNavCategoriesHeader" onClick={() => redirectHome()}>
      <FormattedMessage {...messages.listCategories} />
    </Header>
    {categories.map((category) => (
      <CategoryLink
        key={category.name}
        active={categoryName === category.name ? 1 : 0}
        id={category.name}
        // Workaround here to avoid errors from NavLink
        // More informations here : [https://github.com/styled-components/styled-components/issues/1198]
        to={`${FAQ_URL}/${category.name}`}
      >
        {category.title}
      </CategoryLink>
    ))}
  </Content>
);

Categories.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.exact({
      name: PropTypes.string,
      title: PropTypes.string,
      meta: PropTypes.exact({
        title: PropTypes.string,
        description: PropTypes.string,
      }),
      description: PropTypes.string,
    }),
  ),
  categoryName: PropTypes.string,
  redirectHome: PropTypes.func,
};

export default Categories;
